import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

function UserProfilePage() {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUserProfile();
    fetchUserStories();
  }, [id]);

  const fetchUserProfile = async () => {
    try {
      const response = await fetch(`/api/users/${id}`);
      const data = await response.json();
      if (data.user) setUser(data.user);
    } catch (error) {
      console.error('获取用户资料失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchUserStories = async () => {
    try {
      const response = await fetch(`/api/stories?limit=10`);
      const data = await response.json();
      if (data.stories) {
        // 过滤出该作者的故事
        setStories(data.stories.filter(s => s.author_id === id));
      }
    } catch (error) {
      console.error('获取用户故事失败:', error);
    }
  };

  if (loading) {
    return <div className="text-center py-12">加载中...</div>;
  }

  if (!user) {
    return <div className="text-center py-12 text-red-600">用户不存在</div>;
  }

  return (
    <div>
      {/* 用户资料卡片 */}
      <div className="bg-white p-8 rounded-lg shadow-md mb-8">
        <div className="flex items-center space-x-6">
          <div className="w-24 h-24 bg-primary-100 rounded-full flex items-center justify-center text-4xl">
            {user.avatar_url ? (
              <img src={user.avatar_url} alt={user.username} className="w-full h-full rounded-full" />
            ) : (
              '👤'
            )}
          </div>
          <div>
            <h1 className="text-3xl font-bold">{user.username}</h1>
            <p className="text-gray-600">{user.bio || '这个人很懒，什么都没写~'}</p>
            <div className="flex space-x-4 mt-2 text-sm text-gray-500">
              <span>加入时间：{new Date(user.created_at).toLocaleDateString()}</span>
              {user.role === 'admin' && (
                <span className="bg-red-100 text-red-600 px-2 py-1 rounded">管理员</span>
              )}
            </div>
          </div>
        </div>

        {/* 统计数据 */}
        <div className="grid grid-cols-3 gap-4 mt-8 pt-8 border-t">
          <div className="text-center">
            <div className="text-2xl font-bold text-primary-600">{user.stats?.stories || 0}</div>
            <div className="text-gray-600">故事</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-primary-600">{user.stats?.chapters || 0}</div>
            <div className="text-gray-600">章节</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-primary-600">{user.stats?.followers || 0}</div>
            <div className="text-gray-600">粉丝</div>
          </div>
        </div>
      </div>

      {/* 作者的故事 */}
      <div className="bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-bold mb-6">TA 的作品</h2>
        {stories.length === 0 ? (
          <p className="text-gray-500">暂无作品</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {stories.map(story => (
              <div
                key={story.id}
                className="border rounded-lg p-4 hover:shadow-md transition-shadow"
              >
                <h3 className="text-lg font-bold mb-2">{story.title}</h3>
                <p className="text-gray-600 text-sm line-clamp-2 mb-2">{story.description}</p>
                <div className="flex justify-between text-xs text-gray-500">
                  <span>📖 {story.views || 0}</span>
                  <span>❤️ {story.likes || 0}</span>
                  <span>{new Date(story.updated_at).toLocaleDateString()}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default UserProfilePage;
